// Copyright (c) 2022 Sagacity Solutions Inc. All right reserved.
'use strict';

import HTTP from "./http-server";

export default {
  get: async function() {
    const response = await HTTP.get('v1/settings/notification/');
    if (response.status == 200) {
      return response.data;
    }
    throw new Error(response.data.error || "can't get notification");
  },
  update: async function(id, data) {
    const response = await HTTP.put(`v1/settings/notification/${id}`, data);
    if (response.status == 200) {
      return response.data;
    }
    throw new Error(response.data.error || "can't update notification");
  },
  delete: async function(id) {
    const response = await HTTP.delete(`v1/settings/notification/${id}`);
    if (response.status == 200) {
      return;
    }
    throw new Error(response.data.error || "can't delete notification profile");
  },
  create: async function(data) {
    const response = await HTTP.post(`v1/settings/notification/`, data);
    if (response.status == 200) {
      return response.data;
    }
    throw new Error(response.data.error || "can't create notification profile");
  },
}
